/**
 * This service helps to sort out collision exceptions,
 * i.e. collision behavior for specific item combinations.
 *
 * @class CollisionExceptionService
 */
export default class CollisionExceptionService {
    /**
     * Holds all item combinations which can
     * not collide. Uses <item.type>-<otherItem.type>
     * @property {string[]}
     */
    cannotCollide = [
        'tableleg-connector',
    ];

    constructor() {
        this.cannotCollide = this.initializeCombinations(this.cannotCollide);
    }

    /**
     * Checks if item combination is eligible for
     * collision check
     * @param {ItemInterface} item
     * @param {ItemInterface} otherItem
     *
     * @return {boolean}
     */
    canCollide(item, otherItem) {
        const combination = `${item.type}-${otherItem.type}`;
        return this.cannotCollide.indexOf(combination) < 0;
    }

    /**
     * will read all combinations and add them
     * as well as their reverse versions to a new array
     *
     * @param {Array.<string>} combinations
     * @return {Array.<string>}
     */
    initializeCombinations(combinations) {
        return combinations.concat(combinations.map(combination => combination.split('-').reverse().join('-')));
    }
}
